import axios from 'axios';
import * as env from '../config';
import ENDPOINTS from '../consts/endpoints';

const api = axios.create({
    baseURL: ENDPOINTS.BASE_URL
});

// Intercepta a resposta das requisições e verifica se houve algum erro relacionado a autenticação
// Caso haja algum erro renova o token com o servidor e refaz a ultima requisiçao

// Intercepta todas as requisições enviando juntamente o token setado no localstorage
// Caso o token tenha expirado ou ainda nao tenha sido criado, envia uma requisição  para criar um novo token
api.interceptors.request.use(async (config) => {
    const { token } = env;

    /* istanbul ignore else */
    if (token) {
        config.headers.Authorization = token;
    }

    return config;
});

export default api;
